.fullHeight {
  height: 100%;
}

.projectFilter {
  min-width: 220px;
}

.attentionCard {
  height: 100%;
  cursor: pointer;
  border-top-style: solid;
  border-top-width: calc(var(--ant-line-width-bold) * 2);
}

.attentionValue {
  font-size: var(--ant-font-size-heading-2);
  font-weight: var(--ant-font-weight-strong);
  line-height: var(--ant-line-height-heading-2);
}

.donut {
  flex-shrink: 0;
}

.donutTotal {
  font-size: var(--ant-font-size-heading-3);
  font-weight: var(--ant-font-weight-strong);
  fill: var(--ant-color-text);
}

.donutLabel {
  font-size: var(--ant-font-size-sm);
  fill: var(--ant-color-text-secondary);
}

.legend {
  flex: 1;
}

.projectProgress {
  min-width: 160px;
}

.throughputChart {
  width: 100%;
  height: auto;
}

.throughputLabel {
  font-size: var(--ant-font-size-sm);
  fill: var(--ant-color-text-secondary);
}

.supplyRow {
  padding-inline-start: var(--ant-padding-sm);
  border-inline-start: calc(var(--ant-line-width-bold) * 2) solid;
}

.supplyName {
  flex: 1;
  min-width: 0;
}

.supplyAmount {
  flex-shrink: 0;
  white-space: nowrap;
}

.workloadBar {
  flex: 1;
  min-width: 48px;
}
